import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit,Input, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MonacoEditorConstructionOptions,
  MonacoStandaloneCodeEditor
} from '@materia-ui/ngx-monaco-editor';
import { Icons } from '@vex/icons/icons';
import { DateFormatPipe } from '@vex/pipes/date-format/date-format.pipe';
import { HelperService } from '@vex/services/helper.service';
import { CloudConnectStateService } from '@vex/constants/cloud-connect-state';
import { BlueprintService } from '@vex/http-service/blueprint.service';
import { ResourceSate, Action } from '@vex/model/blueprint-list';
import { MatDialog } from '@angular/material/dialog';
import { formatGenerationError } from '@vex/utils/generation-error';
import { InventoryCompareComponent } from '@app/blue-print-designer/available-blueprint/inventory-compare/inventory-compare.component';
import { DependencyMapService } from '@vex/http-service/dependency-map.service';
import { cloneDeep } from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MonacoEditorService } from '@vex/services/monaco-editor-service.service';
@Component({
  selector: 'vex-pre-deployment-job',
  templateUrl: './pre-deployment-job.component.html',
  styleUrls: ['./pre-deployment-job.component.scss'],
  providers: [DateFormatPipe],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ])
  ]
})
export class PreDeploymentJobComponent extends Icons implements OnInit,OnDestroy {
  @Input() isNeedViewDiff: boolean = true;
  @Input() isShowResourceLevelView: boolean = true;
  @Input() jobs: any = [];
  @Input() targetInventory: any = {};
  displayedResourceColumns: string[] = ['Resources', 'Status'];
  displayedTreeResourceColumns: string[] = ['Resources', 'Status', 'Action'];
  displayedColumns: string[] = ['Jobs', 'Action'];
  expandedJobIndex: number = 0;
  expandedConfigurationIndex: number = 0;
  loadEditor: boolean = false;
  editorOptions: MonacoEditorConstructionOptions = {
    theme: 'vs-dark',
    language: 'typescript',
    roundedSelection: true,
    autoIndent: 'full',
    readOnly: true,
    showDeprecated: false
  };
  ResourceSate = ResourceSate;
  Action = Action;
  jobForms: FormGroup[] = [];
  jobStatusChartData = {
    series: [0, 0],
    chart: {
      type: 'pie',
      width: 250
    },
    labels: ['Conflict', 'Skip'],
    legend: {
      position: 'bottom'
    },
    colors: ['#F44336', '#ffc107']
  };
 private destroy$ = new Subject<void>();
  constructor(
    public helperService: HelperService,
    public cloudConnectStateService: CloudConnectStateService,
    private blueprintService: BlueprintService,
    private dependencyService: DependencyMapService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private monacoEditorService: MonacoEditorService
  ) {
    super();
  }

  copyToClipboard(text) {
    navigator.clipboard
      .writeText(text)
      .then(() => {})
      .catch((error) => {});
  }

  onClickResourceConfiguration(job, resource, index) {
    job['configurationSelectedIndex'] = 0;
    job['expandedConfigurationIndex'] = job['expandedConfigurationIndex'] === index ? null : index;
    job['isGetTerraform'] = false;
    job['isGetCli'] = false;
    job['configurationLoader'] = false;
    job['cliLoader'] = false;
    job['SourceConfiguration'] = false;
    job['TargetConfiguration'] = false;
    job['SourceCLI'] = false;
    job['TargetCLI'] = false;
    job['SourceCode'] = 'Please wait...';
    job['TargetCode'] = 'Please wait...';
    job['SourceCLICode'] = 'Please wait...';
    job['TargetCLICode'] = 'Please wait...';
    job['isEditorShowSeprateCode'] = false;
    job['isEditorShowSeprateCli'] = false;
    job['selectedResourceId'] = resource.SourceResource.Id;
    job['SourceInventory'] = cloneDeep(job['inventory']);
    job['TargetInventory'] = cloneDeep(job['inventory']);
    job.SourceInventory.Blueprint.BlueprintContainers[0].BlueprintCollections = [];
    job.TargetInventory.Blueprint.BlueprintContainers[0].BlueprintCollections = [];
    job.SourceInventory.Blueprint.BlueprintContainers[0].BlueprintCollections.push(
      resource.SourceResource
    );
    let sourceResource = cloneDeep(resource.SourceResource);
    sourceResource.BlueprintChildCollections = [];
    job.SourceInventory.resultBlueprintCollections = [];
    job.SourceInventory.resultBlueprintCollections.push(sourceResource)

    job.TargetInventory.Blueprint.BlueprintContainers[0].BlueprintCollections.push(
      resource.TargetResource
    );
    let targetResource = cloneDeep(resource.TargetResource);
    targetResource.BlueprintChildCollections = [];
    job.TargetInventory.resultBlueprintCollections = [];
    job.TargetInventory.resultBlueprintCollections.push(targetResource)
  }

  onSelectConfigurationTab(index, job) {
    if (index == 1) {
      if (!job['isGetTerraform']) {
        job['configurationLoader'] = true;
        job['isGetTerraform'] = true;
        this.getTerraformCode(job, job['SourceInventory'], 'Source');
        this.getTerraformCode(job, job['TargetInventory'], 'Target');
      }
    } else if (index == 2) {
      if (!job['isGetCli']) {
        job['cliLoader'] = true;
        job['isGetCli'] = true;
        this.getCLICode(job, job['SourceInventory'], 'Source');
        this.getCLICode(job, job['TargetInventory'], 'Target');
      }
    }
  }

  filterTreeviewResource(job, name) {
    job.searchQueryTreeView = name;
    for (let resource of job.ResourceDetails) {
      resource.isHideTreeView =
        name && !resource.TargetResource.CollectionName?.toLowerCase().includes(name.toLowerCase());
    }
  }

  filterConfiguartionResource(job, name) {
    for (let resource of job.ResourceDetails) {
      resource.isHideConfiguration =
        name && !resource.TargetResource.CollectionName?.toLowerCase().includes(name.toLowerCase());
    }
  }

  getConfiguartionResources(job) {
    return job.ResourceDetails?.filter((job) => !job.isHideConfiguration) || [];
  }

  getTerraformCode(job, data, type: string = 'Source') {
    const selectedResourceId = job['selectedResourceId'];
    job.configurationLoader = true;
    job[type + 'Configuration'] = false;
    this.blueprintService.getTerraformCode({ inventory: data }).pipe(takeUntil(this.destroy$)).subscribe(
      (response: any) => {
        if (job['selectedResourceId'] !== selectedResourceId) return;
        job[type + 'Code'] = response.result.trim();
        job[type + 'Configuration'] = true;
        if (job['SourceConfiguration'] && job['TargetConfiguration']) {
          job.configurationLoader = false;
        }
      },
      (error) => {
        if (job['selectedResourceId'] !== selectedResourceId) return;
        job[type + 'Code'] = formatGenerationError(
          error,
          'Error generating Terraform configuration.'
        );
        job[type + 'Configuration'] = true;
        if (job['SourceConfiguration'] && job['TargetConfiguration']) {
          job.configurationLoader = false;
        }
      }
    );
  }

  getCLICode(job, data, type: string = 'Source') {
    const selectedResourceId = job['selectedResourceId'];
    job.cliLoader = true;
    job[type + 'CLI'] = false;
    this.blueprintService
      .generateCliByArtifact({ Type: 'Inventory', Data: data })
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        if (job['selectedResourceId'] !== selectedResourceId) return;
        job[type + 'CLICode'] = response.result;
        job[type + 'CLI'] = true;
        if (job['SourceCLI'] && job['TargetCLI']) {
          job.cliLoader = false;
        }
      }, (error) => {
        if (job['selectedResourceId'] !== selectedResourceId) return;
        job[type + 'CLICode'] = formatGenerationError(
          error,
          'Error generating CLI configuration.'
        );
        job[type + 'CLI'] = true;
        if (job['SourceCLI'] && job['TargetCLI']) {
          job.cliLoader = false;
        }
      });
  }

  onToggleChangeCode(job, change) {
    job.isEditorShowSeprateCode = false;
    if (change.checked) job.isEditorShowSeprateCode = true;
  }

  onToggleChangeCli(job, change) {
    job.isEditorShowSeprateCli = false;
    if (change.checked) job.isEditorShowSeprateCli = true;
  }

  getDefaultAudit(inventory) {
    return {
      UpdatedDate: inventory?.UpdatedDate,
      CreatedDate: inventory?.CreatedDate,
      UpdatedBy: inventory?.UpdatedBy,
      CreatedBy: inventory?.CreatedBy,
      LastCommitMessage: inventory?.LastCommitMessage,
      State: inventory?.State || 0
    };
  }

  getTreeviewResources(job) {
    return job.ResourceDetails?.filter((job) => !job.isHideTreeView) || [];
  }

  searchResource(job, name) {
    for (let resource of job.ResourceGroupedData) {
      resource.isHideSummary =
        name && !resource.ResourceType?.toLowerCase().includes(name.toLowerCase());
    }
  }

  searchJobs(name) {
    for (let job of this.jobs) {
      job.isHide = name && !job.Name?.toLowerCase().includes(name.toLowerCase());
    }
  }

  getJobs() {
    return this.jobs.filter((job) => !job.isHide);
  }

  compareInventory(job) {
    let jobCompare = cloneDeep(job);
    if(jobCompare.newInventory) {
      jobCompare.newInventory.State = 0;
      jobCompare.newInventory.InventoryType = 0;
    }
    const dialogRef = this.dialog.open(InventoryCompareComponent, {
      width: '98%',
      maxWidth: '98vw',
      height: '95%',
      maxHeight: '95vw',
      disableClose: true,
      data: { title: 'Services', SourceInventoryId: jobCompare.Id, TargetInventory: jobCompare.newInventory }
    }).afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((r: any) => {
      });
  }

  getResourcesSummary(job) {
    return job.ResourceGroupedData?.filter((resource) => !resource.isHideSummary) || [];
  }

  getResource(job) {
    let dependencyMapId = job.Blueprint.BlueprintContainers[0].DependencyMapId;
    const dependencyMapIds = [dependencyMapId];
    let newInventory = job.newInventory;
    this.dependencyService.getResourcesByDependencyMap(dependencyMapIds).pipe(takeUntil(this.destroy$)).subscribe((response) => {
      job.ResourceDetails.forEach((resource) => {
        this.updateNewInventoryContainerId(newInventory, resource.SourceResource);
        let data = response.find(
          (dependency) => dependency.CollectionEntryId == resource.TargetResource.CollectionEntryId
        );
        if (data) {
          resource.TargetResource['ImagePath'] = data.ImagePath;
          resource.TargetResource['Description'] = data.Description;
        }
      });
      this.transformDataOfResourcesForCardView(job);
    });
  }

  updateNewInventoryContainerId(newInventory, source) {
    newInventory.Blueprint.BlueprintContainers.forEach((container) => {
      if (source.OldId == container.Id) {
        container = source.Id;
      }
      if (container.BlueprintCollections && container.BlueprintCollections.length > 0) {
        this.updateNewInventoryCollectionId(source, container.BlueprintCollections);
      }
    });
  }

  updateNewInventoryCollectionId(source, collections) {
    collections.forEach((collection) => {
      if (source.OldId == collection.Id) {
        collection.Id = source.Id;
        collection._id = source.Id;
      }
      if (collection.BlueprintChildCollections && collection.BlueprintChildCollections.length > 0) {
        this.updateNewInventoryCollectionId(source, collection.BlueprintChildCollections);
      }
    });
  }

  transformDataOfResourcesForCardView(job) {
    job['jobStatusChartData'] = JSON.parse(JSON.stringify(this.jobStatusChartData));
    let groupedData: any = [];
    job['totalSkipCount'] = 0;
    job['totalConflictCount'] = 0;
    job.ResourceDetails.forEach((resourceDetail) => {
      let resource = groupedData.find(
        (x) => x.CollectionEntryId == resourceDetail.TargetResource.CollectionEntryId
      );
      if (!resource) {
        groupedData.push({
          ResourceType: resourceDetail.TargetResource.CollectionName,
          ResourceImage: resourceDetail.TargetResource.ImagePath,
          CollectionEntryId: resourceDetail.TargetResource.CollectionEntryId,
          Resources: [],
          SkipCount: 0,
          ConflictCount: 0
        });
        resource = groupedData[groupedData.length - 1];
      }
      resource.Resources.push(resourceDetail);
      switch (resourceDetail.TargetResource.ResourceState) {
        case ResourceSate.Skipped:
          resource.SkipCount++;
          job['totalSkipCount']++;
          break;
        case ResourceSate.ConflictDetected:
          resource.ConflictCount++;
          job['totalConflictCount']++;
          break;
        default:
          break;
      }
    });

    job['jobStatusChartData'].series = [job['totalConflictCount'], job['totalSkipCount']];
    job['ResourceGroupedData'] = groupedData;
  }

  ngOnInit() {
    for (let j = 0; j < this.jobs.length; j++) {
      let job = this.jobs[j];
      job['inventory'] = cloneDeep(job);
      job['newInventory'] = cloneDeep(this.targetInventory);
      this.getResource(job);
      this.jobForms.push(this.buildJobForm(job));
    }
  }

  toggleExpandJob(index: number): void {
    this.expandedJobIndex = this.expandedJobIndex === index ? null : index;
  }

  buildJobForm(job: any): FormGroup {
    const resourceArray = this.fb.array([]);

    job.ResourceDetails.forEach((resource: any) => {
      resourceArray.push(
        this.fb.group({
          CollectionEntryId: [resource.TargetResource.CollectionEntryId],
          Action: [
            null,
            resource.TargetResource.ResourceState === ResourceSate.ConflictDetected
              ? [Validators.required]
              : []
          ]
        })
      );
    });

    return this.fb.group({
      JobId: [job.Id],
      ResourceDetails: resourceArray
    });
  }

  getResourcesForm(jobIndex: number): FormArray {
    return this.jobForms[jobIndex].get('ResourceDetails') as FormArray;
  }

  getActionControl(jobIndex: number, resourceIndex: number) {
    return this.getResourcesForm(jobIndex).at(resourceIndex).get('Action');
  }

  submitAll() {
    const result = this.jobForms.map((form) => form.value);
    console.log(result);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.monacoEditorService.destroyEditors(this.editors);
    this.editors = [];
  }

  editors: any[] = [];
  editorInit(editor: MonacoStandaloneCodeEditor) {
    this.loadEditor = false;
    this.editors.push(editor);
    editor.setSelection({
      startLineNumber: 1,
      startColumn: 1,
      endColumn: 50,
      endLineNumber: 3
    });
  }
}
